import { connect } from 'react-redux';
import { createSelector, createStructuredSelector } from 'reselect';
import FrameworkUtils from 'utils/framework';
import LanguageLocaleUtils from 'utils/LanguageLocale';
import SaveToAccountCheckbox from 'components/FrictionlessCheckout/Payment/PaymentMethodList/Paypal/SaveToAccountCheckbox/SaveToAccountCheckbox';
import EditDataActions from 'actions/EditDataActions';
const { updateEditData } = EditDataActions;
import SaveToAccountCheckboxEN from 'components/FrictionlessCheckout/Payment/PaymentMethodList/Paypal/SaveToAccountCheckbox/locales/SaveToAccountCheckbox_en_US';
import SaveToAccountCheckboxFR from 'components/FrictionlessCheckout/Payment/PaymentMethodList/Paypal/SaveToAccountCheckbox/locales/SaveToAccountCheckbox_fr_CA';

const { wrapHOC } = FrameworkUtils;
const { getTextFromResource, getLocalisedDataFromResource } = LanguageLocaleUtils;

const getText = getLocalisedDataFromResource(SaveToAccountCheckboxEN, SaveToAccountCheckboxFR);

const textResources = createStructuredSelector({
    saveToMyAccountCheckbox: getTextFromResource(getText, 'saveToMyAccountCheckbox')
});

const connectedSaveToAccountCheckbox = connect(
    createSelector(textResources, texts => {
        return texts;
    }),
    { updateEditData }
);

const witSaveToAccountCheckbox = wrapHOC(connectedSaveToAccountCheckbox);

export default witSaveToAccountCheckbox(SaveToAccountCheckbox);
